import script from "./ProductAuthList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductAuthList.vue?vue&type=script&setup=true&lang=js"

import "./ProductAuthList.vue?vue&type=style&index=0&id=d250167e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_91df7c0921f9e575f6107cb232f4ee79/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d250167e"]])

export default __exports__